
import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import Path171xPng1x from '../../assets/img/path-17-1x-png@1x.png';
import './index.css';
import './responsive.css';
import countries from "./countries";

const FormSchema = Yup.object().shape({
  firstName: Yup.string()
    .required('Please complete this required field.'),
  lastName: Yup.string()
    .required('Please complete this required field.'),
  companyEmail: Yup.string()
    .email('Email must be formatted correctly.')
    .required('Please complete this required field.'),
  companyName: Yup.string()
    .required('Please complete this required field.'),
  country: Yup.string()
    .required('Please complete this required field.')
});

function FormSection() {
  return (
    <div className="pos_-form-osl3uq">
      <img className="path-17-Mp8JrS" src={Path171xPng1x} />
      
      <div className="boxed">
        <div className="get-in-touch-to-schedule-a-live-demo-Mp8JrS bentonsanscond-light-black-42px">
          Get in touch to schedule a live demo
        </div>

        <div className="group-1238-Mp8JrS">
          <Formik
            initialValues={{
              firstName: '',
              lastName: '',
              companyEmail: '',
              companyName: '',
              country: 'United Arab Emirates',
              agree: false
            }}
            validationSchema={FormSchema}
            onSubmit={(values, actions) => {
              let jsonResponse = {
                "submittedAt": Date.now().toString(), 
                "fields": []
              }

              jsonResponse.fields.push({name: "firstname", value: values.firstName})
              jsonResponse.fields.push({name: "lastname", value: values.lastName})
              jsonResponse.fields.push({name: "company", value: values.companyName})
              jsonResponse.fields.push({name: "email", value: values.companyEmail})
              jsonResponse.fields.push({name: "country", value: values.country})

              axios.post('https://api.hsforms.com/submissions/v3/integration/submit/307663/a19d7ebb-4689-4f80-94c9-b545249c07d1', jsonResponse)
              .then((response) => {
                console.log(response);

                if (response.data.inlineMessage == "Thanks for submitting the form.") {
                  alert("Thank you for your interest in PresentationOS.");
                  actions.resetForm({
                    values: {
                      firstName: '',
                      lastName: '',
                      companyEmail: '',
                      companyName: '',
                      country: 'United Arab Emirates',
                      agree: false
                    }
                  })
                } else {
                  alert("Something went wrong. Please try again.");
                }
              })
              .catch((err) => {
                console.log(err);

                alert("Something went wrong. Please try again.");
              })
            }}
          >
            {({ errors, touched }) => (
              <Form>
                <div className="input-wrapper">
                  <label className="input-label bentonsanscond-light-black-23px" htmlFor="first-name">First Name*</label>
                  <Field className={(touched.firstName && errors.firstName ? "error " : "") + "rectangle-301-vx3zUH border-1px-dove-gray"} type="text" name="firstName" />
                  <ErrorMessage className="errorMessage" name="firstName" component="div" />
                </div>

                <div className="input-wrapper">
                  <label className="input-label bentonsanscond-light-black-23px" htmlFor="last-name">Last Name*</label>
                  <Field className={(touched.lastName && errors.lastName ? "error " : "") + "rectangle-301-vx3zUH border-1px-dove-gray"} type="text" name="lastName" />
                  <ErrorMessage className="errorMessage" name="lastName" component="div" />
                </div>

                <div className="input-wrapper">
                  <label className="input-label bentonsanscond-light-black-23px" htmlFor="company-email">Company Email*</label>
                  <Field className={(touched.companyEmail && errors.companyEmail ? "error " : "") + "rectangle-301-vx3zUH border-1px-dove-gray"} type="email" name="companyEmail" />
                  <ErrorMessage className="errorMessage" name="companyEmail" component="div" />
                </div>

                <div className="input-wrapper">
                  <label className="input-label bentonsanscond-light-black-23px" htmlFor="company-name">Company Name*</label>
                  <Field className={(touched.companyName && errors.companyName ? "error " : "") + "rectangle-301-vx3zUH border-1px-dove-gray"} type="text" name="companyName" />
                  <ErrorMessage className="errorMessage" name="companyName" component="div" />
                </div>

                <div className="input-wrapper">
                  <label className="input-label bentonsanscond-light-black-23px" htmlFor="country">Country*</label>
                  <Field as="select" className={(touched.country && errors.country ? "error " : "") + "rectangle-301-vx3zUH2 border-1px-dove-gray"} name="country">
                    {
                      countries.map((country, index) => (
                        <option key={index} value={country.name}>{country.name}</option>
                      ))
                    }
                  </Field>
                  <ErrorMessage className="errorMessage" name="phoneNumber" component="div" />
                </div>

                <div className="we-love-connecting-a-yEdbQM bentonsanscond-regular-normal-black-19px">
                  We love connecting and sharing insights, news, and content. We never want to spam you, and rest assured that we
                  will never share your contact details with anyone.
                </div>

                <div className="i-agree-to-receive-c-yEdbQM bentonsanscond-regular-normal-black-19px">
                  <Field type="checkbox" name="agree" /> 
                  <span>I agree to receive communications from MBLM.</span>
                </div>

                <div className="by-selecting-the-but-yEdbQM">
                  <span className="bentonsanscond-regular-normal-black-19px">
                    By selecting the button, you agree to our
                    <span> </span>
                    <span className="span1-EK3b7j highlighted bentonsanscond-medium-picton-blue-19px-2" onClick={() => { window.location.href= "https://mblm.com/privacy-policy/" }}>Privacy Policy</span>
                    .
                  </span>
                </div>

                <div className="you-may-withdraw-you-yEdbQM">
                  <span className="bentonsanscond-regular-normal-black-19px">
                    You may withdraw your consent at any time by contacting us at 
                    <span className="highlighted bentonsanscond-medium-picton-blue-19px-2" onClick={() => { window.location.href= "mailto:privacy@mblm.com" }}> privacy@mblm.com</span>
                    .
                  </span>
                </div>

                <button type="submit" className="group-1198-yEdbQM bentonsanscond-regular-normal-black-18px">
                  Submit
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default FormSection;